<template>
	<div>
		<s-box title="GERENCIAMENTO DE RISCOS">
			<div slot="tools">
				<s-btn
					size="sm"
					text="Mapeamento"
					type="success"
					icon="plus"
					@click="abrirModalDimencionamento()"
				/>
			</div>
			<div slot="body">
				<aTable
					ref="tProps"
					actionRead="private-read-dimencionamentos"
					actionDelete="private-delete-dimencionamento"
					:labels="labels"
					:actions="actions"
					@edit="(data) => $refs.mdDimencionamento.open(data)"
					@preview="printPPRA"
				/>
			</div>
		</s-box>
		<md-dimencionamento ref="mdDimencionamento" />
	</div>
</template>
<script>
	import sBox from 'box';
	import sBtn from 'btn';
	import aTable from 'table';
	import sMapRisco from './components/mapRisco/index.vue';
	import mdDimencionamento from './components/dimencionamento/index.vue';
	import WBS from 'js/http';

	import PrintMixin from './mixins/print.js';
	import LoadAsset from './mixins/LoadAssets.js';

	export default {
		components: { sBox, sBtn, aTable, sMapRisco, mdDimencionamento },
		mixins: [PrintMixin, LoadAsset],
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{
						data: [
							'dados_empresa.razao_social',
							'dados_empresa.cnpj',
						],
						label: 'Empresa',
						two: true,
					},
					{
						data: [
							'atividade_principal',
							'dados_tecnicos.atividade_economica',
						],
						label: 'CNAE',
						two: true,
					},
					{
						data: [
							'dados_tecnicos.cipa_grupo',
							'dados_tecnicos.enquadramento',
						],
						label: 'Dados',
						two: true,
					},
					{
						data: ['tecnico_editor.nome', 'tecnico_editor.funcao'],
						label: 'Tecnico',
						two: true,
					},
					// {data: 'evento', label: 'Data'},
					{
						data: 'total_funcionarios',
						label: 'Func.',
						class: 'warning',
					},
				],
				actions: [
					'edit',
					'delete',
					{
						emit: 'preview',
						color: 'btn-warning',
						icon: 'fa-print',
						text: '',
					},
				],
			};
		},

		methods: {
			abrirModalDimencionamento() {
				this.$refs.mdDimencionamento.open();
			},
		},

		mounted() {
			this.$emit('setHeader', ['SST', 'Segurança']);
			// WBS.send('protected-read-clientes', resp => {
			//   if(resp.status == "success"){
			//     this.assets.clientes = resp.data
			//   }
			// })
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sst/seguranca/index.vue